package org.dronda.app.web.ui.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import kotlinx.coroutines.flow.MutableSharedFlow

@Composable
fun <T> collectEventSink(sink: MutableSharedFlow<T>, body: suspend (T) -> Unit) {
    LaunchedEffect(Unit) {
        sink.collect(body)
    }
}
